module.exports = __webpack_public_path__ + "static/img/pico44.1cc3cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico44.png
// module id = VWSs
// module chunks = 0